import React, {useEffect, useRef, useState} from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie, getElementsAtEvent} from 'react-chartjs-2';
import { useSelector, useDispatch } from 'react-redux';
import { ChartFilter } from '../../Components/ChartFilter';
import { handleRequestGetLead } from '../../Store/dashboard/action';
import { handleValidateCodevalue, myTeampermission, permissionList, DEFAULT_CHART_DATE_RANGE_DAYS } from '../../Utility/constant';
import { Typography } from '@mui/material';
import qs from "qs";
import LoaderIcon from '../../Assets/images/loader.svg';
import { requestGetMyTeam } from '../../Store/User/action';
import { resolveOwnerIds, buildChartQueryParams } from '../../Utility/ownerUtils';

ChartJS.register(ArcElement, Tooltip, Legend);

export const options = {
      responsive: true,
      maintainAspectRatio : false,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: false,
          text: 'Lead Status',
        },
      },
    };

    
 

export function LeadClosedChart({dashboarddataset, internationalise, isParentLoading}) {

  const data = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
        refdata: []
      },
    ],
  };

  const [colorArray] = useState(['#4FC8F7','#B5FCCD', '#A1E3CD', '#8DCACC', '#79B1CC', '#1434C9', '#B950CB','#E17FF1', '#F07F92', '#FFCC9C'])
  
  const cloneData = {...data};

  const [piedata, setpiedata] = useState({data, options});
  const [dataset, setdataset] = useState(null);
  const [selectedsection, setselectedsection] = useState(null);
  const [emptydataset, setEmptyDataset] = useState("");
  const chartRef = useRef(null);
  const[isLoading, setIsLoading] = useState(false);
  const [filterData, setFilterData] = useState("");

  const dispatch = useDispatch();

  const [value, setValue] = useState(DEFAULT_CHART_DATE_RANGE_DAYS);

  const currentUser = useSelector(state => state?.owner?.currentuser);
  const myTeam = useSelector(state => state?.owner?.Team);
  const ownerlist = useSelector(state => state?.owner?.ownerlist);  
     
  // const isLoading = useSelector(state=> state?.chart?.isPieChartLoader);
        
  const isFirstRender = useRef(true);
        
  const onChange = (e, isType) => {
      const {value} = e.target;
      setValue(value);
  }

  
  useEffect(() => {
    const fetchChart = async() => {
      setIsLoading(true);
      const allOwnerIds = (ownerlist || []).map(item => item.id);
      const isTeamRequired = currentUser?.authorities?.some(item => myTeampermission?.includes(item?.authority));
      let latestTeam = [];
      if(isTeamRequired && myTeam?.length == 0) {
        latestTeam =  await dispatch(requestGetMyTeam(currentUser?.userId), false);
      }
        const reportingTeamIds = (myTeam?.length > 0 ? myTeam : latestTeam).map(item => item.id);
        const isEntireOrg = currentUser?.authorities?.some(item => item?.authority == permissionList?.ALL_LEAD_MANAGE);

        const params = buildChartQueryParams(
            resolveOwnerIds({
                isEntireOrg,
                allOwnerIds,
                reportingTeamIds,
                currentUserId: currentUser?.userId
            }),
            value
        );

        await dispatch(handleRequestGetLead({params: params, 
            paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
        }))

        setIsLoading(false);
      }

      if (isFirstRender.current) {
          isFirstRender.current = false;
          return;
      }

      if (currentUser) {
          fetchChart();
      }
      
    },[ value, currentUser])

  
  const leadData = useSelector(state => state.chart.lead);

  function getRandomColor(datalength) {
    
    const colorArr = colorArray.slice(0, datalength);
    return colorArr;

  }

  useEffect(() => {
    if(leadData?.length > 0) {
        getoriginalPiechartdata();
    }

  },[leadData]);

  useEffect(() => {
    if(filterData == "" && leadData?.length > 0) {
      getoriginalPiechartdata();
    }
  }, [filterData])

  const handleremoveItem = () => {
    setFilterData("");
    setEmptyDataset("")
  }

  const handleSetclearfilterdata = (item) => {

    setFilterData(item)
  }

  const getoriginalPiechartdata = () => {
    const groupedrecord =  leadData?.reduce((hash, obj) => ({...hash, [obj['status']]:( hash[obj['status']] || [] ).concat(obj)}), {});
      delete groupedrecord[null];
      const graphLabel = Object.keys(groupedrecord).map(item => handleValidateCodevalue(internationalise, item));
      const graphdata = Object.values(groupedrecord);
      data.labels = graphLabel;
      data.datasets[0].data = graphdata.map(item => item.length); 
      data.datasets[0].backgroundColor = getRandomColor(graphLabel?.length) ;
      data.datasets[0].borderColor = getRandomColor(graphLabel?.length);
      data.datasets[0].refdata = Object.keys(groupedrecord);

      setpiedata({
        data: data,
        options: options,
      });
      setdataset(groupedrecord);
  }

  
  const handleclick = (event) => {
    if(getElementsAtEvent(chartRef.current, event).length > 0) {
        const datasetIndex = getElementsAtEvent(chartRef.current, event)[0].datasetIndex;
        const index = getElementsAtEvent(chartRef.current, event)[0].index;
        const pietype = piedata.data.datasets[datasetIndex].refdata[index];
        setselectedsection({pietype, datasetIndex});
        const clickedsectionData = dataset[pietype];
        const curentChart = chartRef.current;
        if(clickedsectionData?.length > 0) {
            const groupedrecord =  clickedsectionData.reduce((hash, obj) => ({...hash, [obj['source']]:( hash[obj['source']] || [] ).concat(obj)}), {});
            delete groupedrecord[null];
            const graphLabel = Object.keys(groupedrecord);
            const graphdata = Object.values(groupedrecord);
            if(graphdata?.length > 0) {
              data.labels = graphLabel;
              data.datasets[0].data = graphdata.map(item => item.length); 
              data.datasets[0].backgroundColor = getRandomColor(graphLabel.length) ;
              data.datasets[0].borderColor = getRandomColor(graphLabel.length);
              data.datasets[0].refdata = graphLabel;

              const newOptions = {
                ...piedata.options,
                plugins: {
                  legend: {
                    position: 'top',
                  },
                  title: {
                    display: false,
                    text: handleValidateCodevalue(internationalise, "LEAD_BY_SOURCE"),
                  }
                }
              }
              setpiedata({
                data: data,
                options: newOptions
              });
              
            } else {
              const value = handleValidateCodevalue(internationalise, "NO_DATA_SET")
              setEmptyDataset(value)
            }
              handleSetclearfilterdata(`${handleValidateCodevalue(internationalise, "LEAD_STATUS")} = ${pietype}`);
            
        }
        
    }
  }

  const showChartLoader = isLoading || isParentLoading;
  
  if(showChartLoader) {
   return ( 
   <div className='piechartContainer' style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100%"}}>
      <img
          src={LoaderIcon}
          alt="loading"
          style={{ width: 60, height: 60, animation: "spin 1.2s linear infinite" }}
        />
    </div>);
  } else {

  return (
    <div className='piechartContainer' style={{ display: "flex", flexDirection: "column", height: "100%" }}>
     <ChartFilter 
          label={filterData ? handleValidateCodevalue(internationalise, "LEAD_BY_SOURCE") : handleValidateCodevalue(internationalise, "LEAD_BY_STATUS")}
          dashboarddataset = {dashboarddataset}
          isType="leadSource"
          filterData={filterData}
          handleremoveItem = {handleremoveItem}
          onChange={onChange}
          value={value}
        />

        <div style={{ position: "relative", flex: 1, minHeight: 0, width: "100%" }}>
            {!emptydataset ? <Pie 
              style={filterData ? {position: 'relative', top: "20px"} : {}}
              data={piedata?.data} 
              options={piedata?.options} 
              ref={chartRef} 
              onClick={handleclick}

            /> : <Typography variant='subtitle2' style ={{display : "flex", justifyContent: "center", height: "100%", alignItems: "center"}}>
                {emptydataset}
            </Typography>}
        </div>
      </div>
  );
}
}
